import { APARTMENT_TYPE, HOUSE_TYPE } from '@wohnsinn/ws-ts-lib';

const getFormattedApartmentType = (type: APARTMENT_TYPE | HOUSE_TYPE, transLateFn: (key: string) => string) => {
  switch (type) {
    case APARTMENT_TYPE.APARTMENT:
      return transLateFn('apartmentType.options.apartment');
    case APARTMENT_TYPE.VACATION_APARTMENT:
      return transLateFn('apartmentType.options.vacationApartment');

    case APARTMENT_TYPE.TERRACE_APARTMENT:
      return transLateFn('apartmentType.options.terraceApartment');
    case APARTMENT_TYPE.BASEMENT:
      return transLateFn('apartmentType.options.basement');
    case APARTMENT_TYPE.GARAGE:
      return transLateFn('apartmentType.options.garage');
    case APARTMENT_TYPE.GROUND:
      return transLateFn('apartmentType.options.ground');
    case APARTMENT_TYPE.HOUSE:
      return transLateFn('apartmentType.options.house');
    case APARTMENT_TYPE.LEVEL:
      return transLateFn('apartmentType.options.level');
    case APARTMENT_TYPE.ROOF:
      return transLateFn('apartmentType.options.roof');
    case APARTMENT_TYPE.ATTIC_APARTMENT:
      return transLateFn('apartmentType.options.roof');
    case APARTMENT_TYPE.MAISONETTE:
      return transLateFn('apartmentType.options.maisonette');
    case APARTMENT_TYPE.LOFT_STUDIO_ATELIER:
      return transLateFn('apartmentType.options.loftStudioAtelier');
    case APARTMENT_TYPE.PENTHOUSE:
      return transLateFn('apartmentType.options.penthouse');
    case APARTMENT_TYPE.GALLERY:
      return transLateFn('apartmentType.options.gallery');
    case APARTMENT_TYPE.RAW_ATTIC:
      return transLateFn('apartmentType.options.rawattic');
    case APARTMENT_TYPE.NONE:
      return transLateFn('apartmentType.options.unknown');
    default:
      return transLateFn('apartmentType.options.apartment');
  }
};

export default getFormattedApartmentType;
